// File: src/components/ThemeToggle/ThemeToggle.tsx

import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { WeatherSunny24Regular, WeatherMoon24Regular } from "@fluentui/react-icons";
import styles from "./ThemeToggle.module.css";

export const ThemeToggle: React.FC = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className={styles.themeToggleContainer}>
            <span className={styles.label}>Theme</span>
            <button className={styles.themeToggle} onClick={toggleTheme} aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}>
                <div className={styles.toggleTrack}>
                    <div className={`${styles.toggleThumb} ${theme === "light" ? styles.light : ""}`}>
                        {theme === "dark" ? <WeatherMoon24Regular className={styles.icon} /> : <WeatherSunny24Regular className={styles.icon} />}
                    </div>
                </div>
            </button>
        </div>
    );
};
